/*
 * Copyright (c) 2023. American Express Company
 */

import React from 'react';
import { IconButtonViewModel } from 'src/types/view-models/icon-button.view.model';
import styles from './IconButton.module.scss';
import {
    ButtonPrimary,
    ButtonPrimaryDark,
    ButtonSecondary,
    ButtonSecondaryDark,
    ButtonTertiary,
    ButtonTertiaryDark
} from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import { ButtonType } from 'src/types/button-type.enum';

export default function IconButton({
    variant,
    icon,
    title,
    size = DLSSize.SMALL,
    className,
    ...props
}: IconButtonViewModel): JSX.Element {
    let ButtonComponent;
    let buttonClass: string;
    switch (variant) {
        case ButtonType.PRIMARY:
            ButtonComponent = ButtonPrimary;
            buttonClass = styles.primary;
            break;
        case ButtonType.PRIMARY_DARK:
            ButtonComponent = ButtonPrimaryDark;
            buttonClass = styles.primaryDark;
            break;
        case ButtonType.SECONDARY_DARK:
            ButtonComponent = ButtonSecondaryDark;
            buttonClass = styles.secondaryDark;
            break;
        case ButtonType.TERTIARY:
            ButtonComponent = ButtonTertiary;
            buttonClass = styles.tertiary;
            break;
        case ButtonType.TERTIARY_DARK:
            ButtonComponent = ButtonTertiaryDark;
            buttonClass = styles.tertiaryDark;
            break;
        case ButtonType.SECONDARY:
        default:
            ButtonComponent = ButtonSecondary;
            buttonClass = styles.secondary;
    }

    const buttonSize: string = size === DLSSize.MEDIUM ? '50px' : '44px';

    return (
        <ButtonComponent
            aria-label={title}
            className={`${className} ${
                variant !== ButtonType.PRIMARY &&
                variant !== ButtonType.SECONDARY_DARK &&
                variant !== ButtonType.TERTIARY_DARK
                    ? styles.iconButton
                    : ''
            } ${buttonClass}`}
            icon={icon}
            theme={{ width: buttonSize, height: buttonSize }}
            {...props}
        />
    );
}
